// extracted by mini-css-extract-plugin
export var growableInput = "_8j-0";
export var tagContainer = "_8j-2";
export var textInput = "_8j-1";